function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgStepComplete(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 25,
    height: 24,
    viewBox: "0 0 25 24",
    fill: "none",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("path", {
    d: "M12.5 0.75C18.7132 0.75 23.75 5.7868 23.75 12C23.75 18.2132 18.7132 23.25 12.5 23.25C6.2868 23.25 1.25 18.2132 1.25 12C1.25 5.7868 6.2868 0.75 12.5 0.75Z",
    fill: "#0FBC71",
    style: {
      fill: "#0FBC71",
      fill: "color(display-p3 0.0588 0.7373 0.4431)",
      fillOpacity: 1
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M12.5 0.75C18.7132 0.75 23.75 5.7868 23.75 12C23.75 18.2132 18.7132 23.25 12.5 23.25C6.2868 23.25 1.25 18.2132 1.25 12C1.25 5.7868 6.2868 0.75 12.5 0.75Z",
    stroke: "#039855",
    style: {
      stroke: "#039855",
      stroke: "color(display-p3 0.0122 0.5957 0.3331)",
      strokeOpacity: 1
    },
    strokeWidth: 1.5
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M17.596 7.39016L10.436 14.3002L8.53602 12.2702C8.18602 11.9402 7.63602 11.9202 7.23602 12.2002C6.84602 12.4902 6.73602 13.0002 6.97602 13.4102L9.22602 17.0702C9.44602 17.4102 9.82601 17.6202 10.256 17.6202C10.666 17.6202 11.056 17.4102 11.276 17.0702C11.636 16.6002 18.506 8.41016 18.506 8.41016C19.406 7.49016 18.316 6.68016 17.596 7.38016V7.39016Z",
    fill: "white",
    style: {
      fill: "white",
      fillOpacity: 1
    }
  }));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgStepComplete);
export default __webpack_public_path__ + "static/media/step-complete.9d6c8e57c136ee252ea7c3a9efad84a5.svg";
export { ForwardRef as ReactComponent };